import { render, staticRenderFns } from "./ProjectSeoOrganization.vue?vue&type=template&id=53dd05d2"
import script from "./ProjectSeoOrganization.vue?vue&type=script&lang=js"
export * from "./ProjectSeoOrganization.vue?vue&type=script&lang=js"
import style0 from "./ProjectSeoOrganization.vue?vue&type=style&index=0&id=53dd05d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports